import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/** SPA 페이지 이동 시 스크롤을 맨 위로 — ScrollReveal 등이 뷰포트 밖에 남아 보이지 않는 문제 방지 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
